import { useState, type ChangeEvent } from 'react';
import { Box, Button, TextField, Typography } from '@mui/material';
import { useLanguage } from '../../../../context/LanguageContext';

interface PurchasePeriodQuickSelectProps {
    onApply: (value: string) => void;
}

const toIsoDate = (date: Date): string => date.toISOString().slice(0, 10);

// Between-editor date values are formatted as "min|max" (see BetweenEditor).
const lastMonthsRange = (months: number): string => {
    const to = new Date();
    const from = new Date(to);
    from.setMonth(from.getMonth() - months);
    return `${toIsoDate(from)}|${toIsoDate(to)}`;
};

function PurchasePeriodQuickSelect({ onApply }: PurchasePeriodQuickSelectProps) {
    const { t } = useLanguage();
    const [months, setMonths] = useState(12);

    const handleMonthsChange = (event: ChangeEvent<HTMLInputElement>) => {
        const parsed = parseInt(event.target.value, 10);
        setMonths(Number.isNaN(parsed) ? 1 : Math.max(1, parsed));
    };

    const handleApply = () => onApply(lastMonthsRange(months));

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap', width: '100%' }}>
            <Typography variant="caption" sx={{ color: '#495057' }}>
                {t('pages.clients.queryBuilder.simple.quickPeriod.prefix')}
            </Typography>
            <TextField
                type="number"
                size="small"
                value={months}
                onChange={handleMonthsChange}
                inputProps={{ min: 1 }}
                sx={{ width: 72 }}
            />
            <Typography variant="caption" sx={{ color: '#495057' }}>
                {t('pages.clients.queryBuilder.simple.quickPeriod.suffix')}
            </Typography>
            <Button size="small" variant="outlined" onClick={handleApply}>
                {t('pages.clients.queryBuilder.simple.quickPeriod.apply')}
            </Button>
        </Box>
    );
}

export default PurchasePeriodQuickSelect;
